import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const fetchPickingDealers = () => apiActionCreator({
  'endpoint': '/pickingProcesses/dealers',
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_PICKING_DEALERS,
    ActionTypes.FETCHED_PICKING_DEALERS,
    [
      ActionTypes.FETCHED_PICKING_DEALERS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const fetchPickingAgencies = () => apiActionCreator({
  'endpoint': '/pickingProcesses/agencies',
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_PICKING_AGENCIES,
    ActionTypes.FETCHED_PICKING_AGENCIES,
    [
      ActionTypes.FETCHED_PICKING_AGENCIES_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const fetchOrders = ({dealer, agency, part, order}) => {
  const dealerFilter = dealer ? `&dealer=${dealer}` : '';
  const agencyFilter = agency ? `&agency=${agency}` : '';
  const partFilter = part ? `&part=${part}` : '';
  const orderFilter = order ? `&order=${order}` : '';

  return apiActionCreator({
    'endpoint': `/pickingProcesses/orders?type=special${dealerFilter}${agencyFilter}${partFilter}${orderFilter}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_ORDERS,
      ActionTypes.FETCHED_ORDERS,
      [
        ActionTypes.FETCHED_ORDERS_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};

export const updateOrders = () => apiActionCreator({
  'endpoint': '/pickingProcesses/orders',
  'authenticated': true,
  'types': [
    ActionTypes.UPDATING_ORDERS,
    ActionTypes.UPDATED_ORDERS,
    [
      ActionTypes.UPDATED_ORDERS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'PUT',
});

export const fetchOrderDetail = (dealerId, agencyId, orderNumber) => apiActionCreator({
  'endpoint': `/pickingProcesses/dealers/${dealerId}/agencies/${agencyId}/orders/${orderNumber}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_ORDER_DETAIL,
    ActionTypes.FETCHED_ORDER_DETAIL,
    [
      ActionTypes.FETCHED_ORDER_DETAIL_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const saveItemsSelected = ({dealerId, agencyId, orderNumber}, sequences) => apiActionCreator({
  'endpoint': `/pickingProcesses/dealers/${dealerId}/agencies/${agencyId}/orders/${orderNumber}`,
  'authenticated': true,
  'types': [
    ActionTypes.SAVING_ITEMS_SELECTED,
    ActionTypes.SAVED_ITEMS_SELECTED,
    [
      ActionTypes.SAVED_ITEMS_SELECTED_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'POST',
  'contentType': 'application/json',
  'data': {sequences},
});

export const printPickingLabelsByOrderNumberAndSequential = (orderNumber, sequential) => apiActionCreator({
  'endpoint': `/pickingProcesses/orders/${orderNumber}/sequences/${sequential}/labels`,
  'authenticated': true,
  'types': [
    ActionTypes.PRINTING_LABELS_BY_ORDER_NUMBER_AND_SEQUENTIAL,
    ActionTypes.PRINTED_LABELS_BY_ORDER_NUMBER_AND_SEQUENTIAL,
    [
      ActionTypes.PRINTED_LABELS_BY_ORDER_NUMBER_AND_SEQUENTIAL_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const clearData = (type) => ({
  'type': ActionTypes.CLEAR_SPECIALS_ORDERS_DATA,
  'payload': type,
});

export const changeStatusForSelectedItem = (position, enabled) => ({
  'type': ActionTypes.CHANGE_STATUS_FOR_SELECTED_ITEM,
  'payload': {position, enabled},
});

export const changeOrdersListPage = (value) => ({
  'type': ActionTypes.CHANGE_ORDERS_LIST_PAGE,
  'payload': value,
});

export const changeOrdersListPageSize = (value) => ({
  'type': ActionTypes.CHANGE_ORDERS_LIST_PAGE_SIZE,
  'payload': value,
});
